import React from 'react';
import { createRoot } from 'react-dom/client';

import axios from 'axios';

import { App } from './blocks/App/App';
import { triggerTwoFaBlock } from './blocks/TwoFaRequired/twoFaBlock';

import './setLang';

// При ответе API 403 TWO_FA_REQUIRED поднимаем флаг блокировки (зачем — см. twoFaBlock).
// callApi ходит через дефолтный axios с validateStatus: () => true, поэтому 403 приходит
// в success-обработчик, а не в reject.
axios.interceptors.response.use((response) => {
    const data = response?.data;
    if (response?.status === 403 && data && typeof data === 'object' && data.error === 'TWO_FA_REQUIRED') {
        triggerTwoFaBlock();
    }
    return response;
});

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('#app');
    if (container) {
        const root = createRoot(container);
        root.render(<App />);
    }
});
